import { render, staticRenderFns } from "./UISettings.vue?vue&type=template&id=79f3f965&scoped=true&"
import script from "./UISettings.vue?vue&type=script&lang=js&"
export * from "./UISettings.vue?vue&type=script&lang=js&"
import style0 from "./UISettings.vue?vue&type=style&index=0&id=79f3f965&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f3f965",
  null
  
)

export default component.exports